// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS:
//   ROOT: app/assets/webpack_entry/core_webpack.wjs.jsx
// MAGIC_DESPROCKET_END
(function() {

  Components.Modals.HeaderBodyClose = createReactClass({
    propTypes: {
        header: PropTypes.element,
        body: PropTypes.element,
    },
    getDefaultProps: function() {
      return {
        header: (<label> Header </label>),
        body: (<label> Body </label>)
      };
    },
    render: function() {
      return (
        <div>
          <div className="modal-header u-border0 u-pv6x">
            <button
              className="close"
              aria-label="Close"
              data-dismiss="modal"
              type="button">
              <Components.Buttons.Close aria-hidden="true"/>
            </button>
            {this.props.header}
          </div>
          <div className="modal-body u-p0x">
            {this.props.body}
          </div>
        </div>
      );
    }
  });

})();
